module.exports = __webpack_public_path__ + "img/setup-5.d17bbd58.png";